<template>
        <div class="header">
            <img @click="goTop" src="../assets/left-arrow.png" class="return" />
            <div class="title">{{title}}</div>
        </div>
</template>

<style scoped>
    .header {
        height: 48px;
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f2f2f2;
        box-sizing: border-box;

    }

    .return {
        width: 22px;
        position: absolute;
        left: 12px;
    }

    .title {
        font-size: 16px;
        font-weight: 600;
        margin-left: 46px;
        width: 100%;
    }
</style>
<script>
export default {
    name: 'app-header',
    methods: {
        goTop () {
            this.$router.push({
                name: 'top'
            })
        }
    },
    props: {
        title: String
    }
}
</script>



// WEBPACK FOOTER //
// src/components/AppHeader.vue